$(function () {
  $.support.cors = true;
  $.ajaxSetup({
    cache: true
  });

  Handlebars.registerHelper('for', function (from, to, incr, block) {
    var accum = '';
    for (var i = from; i < to; i += incr) {
      var data = {};
      data.index = i;
      data.indexPlusOne = i + 1;
      var uncompiled = block.fn(data);
      accum += Handlebars.compile(uncompiled)(data);
    }
    return accum;
  });

  Handlebars.registerHelper('ifCond', function (v1, v2, options) {
    if (v1 === v2) {
      return options.fn(this);
    }
    return options.inverse(this);
  });

  $('#popupMessageModal').on('hidden.bs.modal.bs.modal', function (e) {
    clearPopupMessage();
  });

  setupNewFeatureNotification();
});

function setupGlobalHeadersFooters() {
  $("#global_header").load("/pages/BS3/global_header.html", function () {
    $("#navcontact").addClass("active");
    setupNewFeatureNotification();
  });
  $("#global_footer").load("/pages/BS3/top_footer.html", function () {
  });
}

function setupNewFeatureNotification() {
  // Notification data is an object with isRead and lastModified as attributes
  var notificationData = {};
  var notifDataString = localStorage.getItem('notificationData');
  if (notifDataString) {
    notificationData = JSON.parse(notifDataString);
  }

  if (notificationData && !notificationData.isRead) {
    $('li[id="navNewFeatures"] i').addClass('new');
  } else {
    InFlight.CMS.getNewFeatures().then(function (resp) {
      if (!(resp && resp.length)) {
        return;
      }

      var page = resp[0];
      var modifiedDate = new Date(page.modified_date);
      var lastModified = notificationData.lastModified ? new Date(notificationData.lastModified) : new Date(1990);
      if (modifiedDate > lastModified) {
        notificationData.isRead = false;
        notificationData.lastModified = lastModified;
        localStorage.setItem('notificationData', JSON.stringify(notificationData));

        $('li[id="navNewFeatures"] i').addClass('new');
      }
    });
  }
}

function clearPopupMessage() {
  $('#popupMessageTitle,#popupMessageContent').text('');

  // set the focus to the first erroneous input, if applicable
  var $errorInputs = $('.PSERROR');
  if ($errorInputs.length) {
    setTimeout(function () {
      $errorInputs.first().focus();
    }, 50);
  }
}

function clearAttachmentWrapper() {
  $('#attachmentWrapperModal').modal('hide');
  return false;
}

$("#attachmentWrapperModal").on('show.bs.modal', function () {
  var $downloadButton = $("#downloadButton");
  var href = $downloadButton.attr('href');
  href = href.replace('/NLX3/', '/');
  $downloadButton.attr('href', href);
});

var possibleBackgrounds = [
  '/images/AdobeStock_72906955.jpg',
  '/images/AdobeStock_168560130.jpg',
  '/images/AdobeStock_190152717.jpg'
];
function randomizeBackgroundNow(picIndex) {
  var homeElement = document.getElementById('main');
  if (homeElement) {
    var rnd = Math.floor(Math.random() * possibleBackgrounds.length);
    var imageUrl;

    if (picIndex === undefined || picIndex === null || picIndex === -1) {
      var lastPicIndex = sessionStorage.getItem('lastPicIndex');
      if (lastPicIndex == 'null') lastPicIndex = null;
      if (lastPicIndex != null) picIndex = Number(lastPicIndex);
    }

    if (picIndex >= 0 && picIndex < possibleBackgrounds.length) {
      console.log('using hard coded background image: ' + picIndex);
      imageUrl = possibleBackgrounds[picIndex];
    } else {
      imageUrl = possibleBackgrounds[rnd];
      sessionStorage.setItem('lastPicIndex', rnd);
    }

    homeElement.style.background = 'no-repeat center center fixed';
    homeElement.style.backgroundImage = "url('" + imageUrl + "')";

    homeElement.style['-moz-background-size'] = 'cover';
    homeElement.style['-o-background-size'] = 'cover';
    homeElement.style['-webkit-background-size'] = 'cover';
    homeElement.style['background-size'] = 'cover';
  }

  if ($.popover) {
    $('[data-toggle="popover"]').popover();
  }
}

function randomizeBackground(picIndex) {
  setTimeout(function () {
    randomizeBackgroundNow(picIndex);
  }, 100);
}

function commonCleanup(picIndex, data, pageTitle) {
  setPageTitle(pageTitle);

  setPageHeader();

  // assign active staus to the active nav tab
  $("ul.nav>li[selectionID='selected']").each(function () {
    $(this).addClass('active');
  });

  //use a red required asterisk, remove colons and Required text from PS
  $('.control-label').each(function () {
    var text = $(this)
      .clone() //clone the element
      .children() //select all the children
      .remove() //remove all the children
      .end() //again go back to selected element
      .html();

    if (text.indexOf(': Required') >= 0 || text.indexOf('*') >= 0) {
      $(this).addClass('required');
      text =
        text.replace(': Required', '').replace('*', '') +
        "<span class='sr-only'>(Required)</span>";
    }
    text = text.replace(':', '');
    $(this).html(text);
  });

  //fix up radio initial states
  var radios = document.querySelectorAll('input[type=radio]');
  for (var i = 0; i < radios.length; i++) {
    if (radios[i].checked) {
      $(radios[i].parentNode).addClass('active');
    }
  }

  //fix up dropdows cast as buttons
  $("[data-if-use-as-related-input='true']").each(function () {
    var $source = $(this);
    var sourceName = $source.attr('name');
    if (!sourceName) {
      sourceName = $source.attr('id');
    }
    if (sourceName) {
      $source
        .parent()
        .find("input[type='radio']")
        .each(function () {
          var $this = $(this);
          $this.attr('data-if-related-input', sourceName);
          $this.attr('name', sourceName);
        });
    }
  });

  //fixup date fields
  $('input[data-bstype=date]').each(function () {
    var $this = $(this);
    var dateFormat = 'mm/dd/yyyy';
    var ifDateFormat = $this.data('if-date-format');
    if (ifDateFormat && ifDateFormat.length >= 3) {
      ifDateFormat = ifDateFormat.substring(0, 3).toLowerCase();

      switch (ifDateFormat) {
        case 'dmy':
          dateFormat = 'dd/mm/yyyy';
          break;
        case 'mdy':
          dateFormat = 'mm/dd/yyyy';
          break;
        case 'ymd':
          dateFormat = 'yyyy/mm/dd';
          break;
      }
    }
    $this.datepicker('remove');
    $this.datepicker({ orientation: 'top', format: dateFormat });
    var dateVal = $this.val();
    if (dateVal) {
      $this.datepicker('update', dateVal);
    }

    var $helpBlock = $this
      .parent()
      .parent()
      .find('.help-block');
    $helpBlock.text(
      $helpBlock.text().replace('[[if-date-format]]', dateFormat)
    );
  });

  //show footer
  $(document).on('NLX:pageComplete', function () {
    InFlight.Utils.showGlobalFooter();
  });

  //add error className to time text inputs
  $('.PSERROR').removeClass('PSERROR');
  var errorInputs = document.querySelectorAll('[tmpclass=PSERROR]');
  var errorText = $('#error_items').html();
  var isError = errorText && errorText.length > 0;
  for (var i = 0; i < errorInputs.length; i++) {
    $(errorInputs[i]).addClass('PSERROR');
    isError = true;
  }
  // If a button group has children with the PSERROR class, apply the PSERROR to the outer group instead of the members
  $('div.btn-group:has(span.PSERROR)')
    .addClass('PSERROR')
    .find('span.PSERROR')
    .removeClass('PSERROR');

  // fix disabled button groups
  $('div.btn-group>label:has(input[disabled])').addClass('disabled');

  //be extra obvious which disabled item is selected vs not selected
  $('label.btn').each(function () {
    if (!$(this).hasClass('active') && $(this).hasClass('disabled')) {
      console.log('faded a disabled not active label');
      $(this).css('opacity', '0.14');
    }
  });

  // fix up DVBE tab labels
  var $scriptPuller = $('#scriptPuller');
  if ($scriptPuller.length > 0) {
    var scriptText = $scriptPuller.attr('data-if-script');
    if (scriptText) {
      if (
        scriptText.indexOf(
          'if  ((2 == 2) && (tabContainer.firstChild.firstChild.firstChild.childNodes[i].firstChild.firstChild.innerHTML == "Employee/Taxes"))'
        ) > -1
      ) {
        $("a:contains('Employee/Taxes')").text('Taxes');
      }
    }
  }

  cleanupForADA(data, isError);

  return isError;
}

function getPageTitle() {
  var $titleElement,
    $containerElement = $("div.container.whiteback:not([class*='if-hide'])");
  if (!$containerElement.length) {
    $containerElement = $("div.container:not([class*='if-hide'])");
  }
  if ($containerElement.length) {
    $containerElement = $containerElement.first();
    // try for any direct h1..h4
    $titleElement = $containerElement.children('h1,h2,h3,h4');
    if (!$titleElement.length) {
      // try looking for h1..h4 in the first div
      if ($containerElement.children('div').length) {
        $titleElement = $containerElement
          .children('div')
          .first()
          .find('h1,h2,h3,h4');
      } else if ($containerElement.children('form').length) {
        // re-base from the first form in the container and try again
        $containerElement = $containerElement.children('form').first();

        // try for any direct h1..h4
        $titleElement = $containerElement.children('h1,h2,h3,h4');
        if (!$titleElement.length) {
          // try looking for h1..h4 in the first div
          if ($containerElement.children('div').length) {
            $titleElement = $containerElement
              .children('div')
              .first()
              .find('h1,h2,h3,h4');
          }
        }
      }
    }
  }
  if ($titleElement && $titleElement.length) {
    return $titleElement.first().text();
  }
}

function setPageTitle(pageTitle) {
  if (!pageTitle) {
    pageTitle = getPageTitle();
  }
  if (pageTitle) {
    var trimmed = pageTitle.trim();
    if (trimmed) {
      document.title = trimmed;
    }
  }
}

function authorizeApps(completeCallback) {
  $('[data-if-app-name]').addClass('hidden');
  if (InFlight.User.isLoggedIn()) {
    InFlight.User.getApps(function (data) {
      if (data && data.apps) {
        for (var i = 0; i < data.apps.length; i++) {
          var app = data.apps[i];
          if (app && app.items) {
            for (var j = 0; j < app.items.length; j++) {
              var item = app.items[j];
              var $el = $('[data-if-app-name="' + item.name + '"]');

              $el.removeClass('hidden');
              if (item.link) {
                $el.data('if-app-link', item.link);

                if (item.system) {
                  $el.data('if-app-system', item.system);
                }
                $el.off().on('click', function () {
                  var $this = $(this);
                  var system = $this.data('if-app-system');
                  var baseUrl = '';
                  switch (system) {
                    case 'authss':
                      baseUrl = InFlight.NLX.Cfg.Customer.psAuthSSAliasRootUrl() ;
                      break;
                    default:
                      baseUrl = InFlight.NLX.Cfg.Customer.psProxyBaseUrl();
                  }

                  InFlight.GTM.home.appClick($this.data('if-app-name'));
                  let aUrl = baseUrl + $this.data('if-app-link');
                  if(system==='authss') {
                    if (aUrl.indexOf('?') > -1) {
                      aUrl = aUrl + "&IFRedirect=true&Proxy=true"
                    } else {
                      aUrl = aUrl + "?IFRedirect=true&Proxy=true"
                    }
                  }
                  window.open(aUrl, '_blank');
                });
              }

              if (item.template) {
                $el.data('if-app-template', item.template);
                $el.off().on('click', function () {
                  var $this = $(this);
                  InFlight.GTM.home.appClick($this.data('if-app-name'));
                  self.location.href = $(this).data('if-app-template');
                });
              }

              if (!item.link && !item.template) {
                //just track
                $el.off().on('click', function () {
                  var $this = $(this);
                  InFlight.GTM.home.appClick($this.data('if-app-name'));
                });
              }
            }
          }
        }
      }

      if (completeCallback) {
        completeCallback();
      }
    });
  }
}

function setPageHeader() {
  authorizeApps();
  if (InFlight.User.isLoggedIn()) {
    $('#login_tpl').hide();
    $('#logout_tpl').show();

    $('#user-block #user-name').text(InFlight.User.currentUser());
    $('#changePasswordHeaderItem').show();

    InFlight.User.getUserInfo().then(function (userInfo) {
      if (userInfo) {
        $('#user-roles').removeClass("hidden");
        $statusPill = $('#status-pill');

        if (userInfo.length === 1) {
          switch (userInfo[0].accountType) {
            case InFlight.User.States.ACCOUNT_TYPE_SUBCONTRACTOR:
              $statusPill.text($.i18n('header_subcontractor'));
              break;
            case InFlight.User.States.ACCOUNT_TYPE_SUPPLIER_ISSUES:
            case InFlight.User.States.ACCOUNT_TYPE_APPROVED_SUPPLIER:
            case InFlight.User.States.ACCOUNT_TYPE_INACTIVE:
            case InFlight.User.States.ACCOUNT_TYPE_UNAPPROVED_SUPPLIER:
            case InFlight.User.States.ACCOUNT_TYPE_BLOCKED:
              $statusPill.text($.i18n('header_bidder_supplier'));
              break;
          }
        } else {
          $statusPill.text($.i18n('header_multicompany'));
        }
      }
      $('#user-block #user-name').text(InFlight.User.currentUser());
    });

    if (sessionStorage.isBidder == 'true') {
      $('#editAccountHeaderItem').show();
    } else {
      $('#editAccountHeaderItem').hide();
    }
  } else {
    $('#login_tpl').show();
    $('#logout_tpl').hide();
    $('#changePasswordHeaderItem').hide();
  }
}

function cleanupForADA(data, isError) {
  //fix up missing "for" attibute for labels
  $('.control-label:not([for]):not(.if-hide)').each(function () {
    linkRelatedInputToLabel($(this));
  });
  $(".control-label[for='']:not(.if-hide)").each(function () {
    linkRelatedInputToLabel($(this));
  });

  // Add aria-label attributes to elements with placeholders
  $('[placeholder]:not([aria-label])').each(function () {
    $(this).attr('aria-label', $(this).attr('placeholder'));
  });

  // Fix button glyphs for screen readers
  //  first, add aria-hidden="true" for all i underneath a button
  $('button i').attr('aria-hidden', 'true');

  // next, add an appropriate sr-only span for glyph-only buttons
  $('button')
    .filter(function () {
      return $.trim($(this).text()) === '';
    })
    .each(function () {
      var srText,
        $this = $(this);

      if ($this.find("i[class*='fa-times']").length) srText = 'Delete';
      else if ($this.find("i[class*='fa-plus']").length) srText = 'Add';
      else if ($this.find("i[class*='fa-search']").length) srText = 'Look up';
      // TODO: flesh these out

      // now insert the sr-only text
      if (srText) {
        $this.append('<span class="sr-only">' + srText + '</span>');
      }
    });

  // Restore target button focus
  var targetFocusSelector = sessionStorage.getItem('lookupFocusSelector'); // lookupFocusSelector can survive a page change;  tFS can't

  if (targetFocusSelector == 'null') targetFocusSelector = null;
  if (targetFocusSelector) {
    sessionStorage.removeItem('lookupFocusSelector');
  } else {
    targetFocusSelector = sessionStorage.getItem('targetFocusSelector');
  }

  if (targetFocusSelector == 'null') targetFocusSelector = null;
  if (targetFocusSelector) {
    sessionStorage.removeItem('targetFocusSelector');

    var $target = $(targetFocusSelector);
    if ($target.length) {
      $target = $target.first();
      if ($target.closest('[data-toggle]').length) {
        var $targetParent = $target.closest('[data-toggle]');
        if ($targetParent.find(':checked').length) {
          $targetParent.find(':checked').first();
        }
      }

      setTimeout(function () {
        $target.focus();
      }, 50);
    }
  }

  if (isError) {
    // Link the problem input field back to the error description
    var $errorInputs = $('.PSERROR'),
      $firstInput;
    var errorDescID = 'error_items';
    if (!$('#' + errorDescID).length) {
      errorDescID = 'error_box';
    }
    if (!$('#' + errorDescID).length) {
      errorDescID = null;
    }

    if ($errorInputs.length && errorDescID) {
      $firstInput = $errorInputs.first();
      $errorInputs.each(function () {
        $(this).attr('aria-describedby', errorDescID);
      });
    } else {
      $firstInput = $("input:not([type='hidden'])").first();
      if ($firstInput.length && errorDescID) {
        $firstInput.attr('aria-describedby', errorDescID);
      }
    }
    if ($firstInput.length) {
      setTimeout(function () {
        $firstInput.focus();
      }, 50);
    }
  }
}

function linkRelatedInputToLabel(labelElem) {
  // TODO: when a target element is found, ensure it has an ID (i.e., copy the name attribute if id is missing)

  var firstTarget,
    possibleTargetParent,
    targetParents,
    possibleInput,
    targetTypes = ['input', 'select', 'span'];
  targetTypes = targetTypes.map(function (i) {
    return i + ':not(.if-hide)';
  });

  //try a direct sibling
  possibleInput = labelElem.next(targetTypes.join(','));
  if (possibleInput.length > 0) {
    labelElem.attr('for', possibleInput.attr('id'));
  } else {
    //try a buried sibling of this label
    targetParents = targetTypes.map(function (i) {
      return 'div:has(' + i + ')';
    });
    possibleTargetParent = labelElem.next(targetParents.join(','));
    if (possibleTargetParent.length > 0) {
      firstTarget = possibleTargetParent.find(targetTypes.join(',')).first();
    } else {
      //try a sibling of the parent of this label
      possibleTargetParent = labelElem
        .parent()
        .find(targetTypes.join(','))
        .filter(function () {
          return $.trim($(this).text()) !== $.trim(labelElem.text());
        });
      if (possibleTargetParent.length > 0) {
        firstTarget = possibleTargetParent.first();
      }
    }

    if (firstTarget && firstTarget.length) {
      labelElem.attr('for', firstTarget.attr('id'));
    }
  }
}

function cleanRawPSPage(preserveLinks, $scope) {
  if (!$scope) {
    // set our scope
    $scope = $("[data-if-label='psPage']:first");

    // Since we're using the default scope, retouch the background

    var $titleElement,
      $containerElement = $("div.container.whiteback:not([class*='if-hide'])");

    if (!$containerElement.length) {
      $containerElement = $("div.container:not([class*='if-hide'])");
    }
    if ($containerElement.length) {
      $containerElement = $containerElement.first();
      $containerElement.removeClass('container').addClass('container-fluid');
    }
  }
  $('table.PSLEVEL1GRID', $scope).attr('border', 1);
  $('img[onclick],a img', $scope).attr('data-if-preserve', 'true');

  $('.PSPUSHBUTTONDISABLED').addClass('if-hide');

  $('img:not([data-if-preserve])', $scope).remove();
  $('img[data-if-preserve]', $scope).removeAttr('data-if-preserve');

  var ifPrefix = InFlight.NLX.Cfg.Customer.ifPrefix();
  if (ifPrefix) {
    $('img[src]', $scope).each(function () {
      var $this = $(this);
      var thisSrc = $this.attr('src');
      $this.attr('src', ifPrefix + thisSrc);
    });
  }

  if (preserveLinks) {
    $('table.PSLEVEL1GRIDWBO>tbody>tr td.PSLEVEL1GRIDLABEL', $scope).each(
      function () {
        var $this = $(this);
        $this.html($this.html().replace('|', ''));
        $this.find("a[id*='$hfind'],a[id*='$hmodal'],a[id*='$hpers']").remove();
      }
    );

    $('a', $scope)
      .removeAttr('class')
      .removeAttr('title')
      .each(function () {
        var $this = $(this);
        var thisHref = $this.attr('href');
        if (thisHref && !(thisHref.indexOf('mailto') == 0)) {
          thisHref = thisHref.replace(
            /submitAction_win[0-9]*/,
            'InFlightPSHelper.submitAction_win0'
          );
          if (thisHref.indexOf('void 0') == -1) {
            thisHref += '; void 0';
            thisHref = thisHref.replace(';;', ';');
          }

          $this.attr('href', thisHref);
        }
      });

    $("input[type='button']", $scope).attr('data-if-ps-clickable', 'true');
  } else {
    $(
      'table.PSLEVEL1GRIDWBO>tbody>tr:has(td.PSLEVEL1GRIDLABEL)',
      $scope
    ).remove();
    $('a', $scope)
      .removeAttr('href')
      .removeAttr('class')
      .removeAttr('title');
    $('img[onclick]', $scope).remove();
  }

  $('*[onclick]', $scope).removeAttr('onclick');
  $('*[onmouseout]', $scope).removeAttr('onmouseout');
  $('*[onmouseover]', $scope).removeAttr('onmouseover');
}

function setCheckboxInputFlag(e, prefix, valOn, valOff) {
  if (valOn == null) valOn = 'Y';
  if (valOff == null) valOff = 'N';
  var hiddenFieldName = '';
  if (prefix.length > 0) {
    hiddenFieldName =
      '[name="' + e.name.replace(prefix, prefix + '$chk') + '"]';
  } else {
    hiddenFieldName = '[name="' + e.name + '$chk"]';
  }

  var $targetInput = $(hiddenFieldName);
  $targetInput.attr('value', e.checked ? valOn : valOff);
}

function fixDateInputsBeforeClick() {
  var dateFields = document.querySelectorAll('input[data-bstype=date]');
  for (var i = 0; i < dateFields.length; i++) {
    var inputDateString = dateFields[i].value;
    var formattedDate = InFlightPSHelper.getPeopleSoftSlashesDate(
      inputDateString
    );
    dateFields[i].value = formattedDate;
  }
}

function clearSpan(textInput, id) {
  console.log('clearSpan: ' + id);
  if (textInput.value.length == 0) {
    $('#' + id).html('');
  }
}

function checkForReturn(e, domId) {
  if (e.keyCode == 13) {
    console.log('checkForReturn: return key detected! ' + domId);
    document.getElementById(domId).click();
    return true;
  }
  return false;
}

function ifReturn(e, cb) {
  if (e.keyCode == 13) {
    console.log('ifReturn: return key detected! ');
    cb();
    return true;
  }
  return false;
}

function processAddField(map, countProxy, config) {
  var initialParams = '';
  for (i = 0, len = map.length; i < len; ++i) {
    var itemCount = $("[id^='" + countProxy + "'][data-if-cloned-from]").length;
    if (!itemCount) {
      itemCount = $("[id^='" + countProxy + "']").length;
    }
    initialParams +=
      map[i].target + itemCount + '=' + $(map[i].source).val() + '&';
    $(map[i].source).val('');
  }

  config.initialParams = initialParams.replace(/&+$/, '');
}

function processLookupField(map, config, $clickedObj) {
  var $relatedInput = $clickedObj
    .closest(map.parent)
    .find("[data-if-label='" + map.input + "']");
  if ($relatedInput.val().length > 0) {
    var $relatedAdd = $clickedObj
      .closest(map.parent)
      .find("[data-if-label='" + map.add + "']");
    $clickedObj.attr('data-if-ps-icaction', $relatedAdd.attr('id'));
    var lastNumberRegex = /(.*)(\d+)(?!.*\d)/g;
    var match;

    if ((match = lastNumberRegex.exec($clickedObj.attr('id'))) !== null) {
      var prefix = match[1];
      var ordinal = match[2];
      ordinal++;
      config.initialParams = 'ICAction=' + prefix + ordinal;
    }
  }
}

function confirmLeavingSite(newLocation) {
  $('#leaveSiteModal').modal('show');
  $('#leaveSiteModal_location').html(newLocation);

  //var resp = window.confirm("This link opens in a new tab.");
  //if (resp == true)
  //{
  //  window.open(newLocation, '_blank');
  //}
}

function clearLeaveSiteModal() {
  $('#leaveSiteModal').modal('hide');
}

function openNewTab() {
  window.open($('#leaveSiteModal_location').html(), '_blank');
}

/* checkValidSession() will invalidate all ps-clickables on the page */
//var oldTimeout = setTimeout(function() {  checkValidSession(); }, 30000);
function checkValidSession() {
  console.log('*** checkValidSession() ***');
  if (InFlight.User.isLoggedIn()) {
    var myCheckConfig = {
      showLoading: false,
      targetUrl:
        InFlight.NLX.Cfg.Customer.psRootUrl() +
        '/c/MAINTAIN_SECURITY.CHANGE_PASSWORD.GBL',
      followProposedTemplate: false,
      currentState: 'CheckSession',

      manualRequestObj: [
        {
          Lbl: 'changePasswordButton',
          Src: '#DERIVED_PSWD_CHANGE_PWD_BTN',
          Data: 'id'
        }
      ],

      afterProcessResponse: function (data) {
        console.log(
          '-------------- CHECK SESSION afterProcessResponse ' +
          JSON.stringify(data, null, 4)
        );

        if (
          data.Info.ReferringTarget != null &&
          data.Info.ReferringTarget.indexOf('errorCode=127') > 0
        ) {
          console.log('*** SESSION time out! ***');
          InFlight.User.clearLogin(function () {
            window.location.href = '/pages/BS3/login.aspx?sessionTimeout=true';
          });
        } else {
          console.log('*** SESSION is valid ***');
        }
      }
    };

    //first load menu helper
    var InFlightPSMenuHelper = new InFlightPSHelperType();
    InFlightPSMenuHelper.init(myCheckConfig);
  }

  if (typeof oldTimeout !== 'undefined' && oldTimeout != null) {
    console.log('*** clearing old timeout!');
    clearTimeout(oldTimeout);
  }
  oldTimeout = setTimeout(function () {
    checkValidSession();
  }, 30000);
}

// we need to initialize the responsive table labels
function initResponsiveTables() {
  // add the data-label attribute to all td using the text value of the associated th
  $('table.table-responsive').each(function (i) {
    var table = $(this);
    $(this)
      .find('th')
      .each(function (j) {
        var $th = $(this);
        if ($th.hasClass('show-mobile')) {
          var t = $th.text();
          t = t.replace('<br>', ' ').replace(/&nbsp;/gi, '');
          table
            .find('tr:not(.if-hide) td:nth-child(' + j + ')')
            .attr('data-label', t);
        }
      });
  });
}

var BootstrapBreakpoint = {
  xs: {
    min: 0,
    max: 767
  },
  sm: {
    min: 768,
    max: 991
  },
  md: {
    min: 992,
    max: 1199
  },
  lg: {
    min: 1200,
    max: 99999
  }
};

var PortalUrl = (function () {
  var _window;

  var openLoadingWindow = function (url) {
    var url = url || '/pages/loading.html';
    _window = window.open(url, '_blank');
  };

  var _hasDoPortalUrl = function (data) {
    if (data && data.CaptureResults && data.CaptureResults.doPortalUrlText) {
      return true;
    } else {
      return false;
    }
  };

  var checkUrlAndGo = function (data, templatePath, sessionKey) {
    if (_hasDoPortalUrl(data)) {
      var doPortalUrlText =
        data.CaptureResults.doPortalUrlText[0].Properties.text;
      var matches = doPortalUrlText.match("DoPortalUrl\\('([^']*)'\\)");
      if (matches) {
        localStorage.setItem(sessionKey, matches[1]);
        var viewDetailsUrl =
          templatePath +
          '?' +
          matches[1].substring(matches[1].indexOf('?') + 1);

        if (!_window) {
          _window = window;
        }

        _window.location.href = viewDetailsUrl;
      }
    }
  };

  var prepareTargetUrl = function (targetUrl, sessionKey) {
    if (sessionKey) {
      var path = localStorage.getItem(sessionKey);
      if (path) {
        targetUrl = path.replace('/psp/', '/psc/');
        localStorage.removeItem(sessionKey);
      }
    }
    return targetUrl;
  };

  return {
    openLoadingWindow: openLoadingWindow,
    checkUrlAndGo: checkUrlAndGo,
    prepareTargetUrl: prepareTargetUrl
  };
})();

function setField(name, value) {
  var field = $('[name="' + name + '"]');
  if (value == null) {
    field.remove();
  } else if (field.length > 0) {
    field.val(value);
  } else {
    $('<input/>', {
      name: name,
      value: value,
      type: 'hidden'
    }).appendTo(form);
  }
}
var SCROLL_SUFFIX = 'scroll';

var PS_RELAY_HISTORY_LENGTH_KEY = 'ps-relay-history-length';

function setRelayHistoryLength() {
  if (!sessionStorage.getItem(PS_RELAY_HISTORY_LENGTH_KEY)) {
    sessionStorage.setItem(PS_RELAY_HISTORY_LENGTH_KEY, history.length);
  }
}

$(document).on('NLX:pageStart', function () {
  sessionStorage.removeItem('targetFocusSelector');
  InFlight.Utils.hideGlobalFooter();
});

InFlight.i18n.setup();

InFlight.handlebars.registerHerlpers();

function isLBE() {
  if (location.search && location.search.indexOf('lbe=true') !== -1) {
    setLBE(true);
    return true;
  }

  return sessionStorage.getItem('lbe') === 'true';
}

function setLBE(val) {
  if (val) {
    sessionStorage.setItem('lbe', 'true');
  } else {
    sessionStorage.removeItem('lbe');
  }
}

function formContainsIllegal(input, illegal) {
  var hasMarkup = false;
  if (input === undefined) {
    input = "input:text, textarea";
  }

  if (illegal === undefined) {
    illegal = ";";
  }

  $(input).each(function () {
    if ($(this).val().includes(illegal)) {
      // we have some sort of markup in this field
      $(this).parent().addClass("has-error markup-error");
      $("#popupMessageContent").removeClass('if-hide').html("&nbsp;" + illegal + " is not allowed. <br><br>  Remove&nbsp;" + illegal + "&nbsp;to continue.")
      $('#popupMessageModal').modal("show");
      hasMarkup = true;
    } else {
      $(this).parent('.markup-error').removeClass("has-error markup-error");
    }
  });
  return hasMarkup;
}
